import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { invoiceKeys, jobKeys } from '@/lib/queryKeys';
import { jobEndpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api/client';

/**
 * Raise a prepaid series' term invoice — for a series that never got one. The
 * server bills the term once; a repeat returns the invoice already raised.
 */
export function useBillPrepaidTerm(jobId: string) {
  const queryClient = useQueryClient();

  return useApiMutation<{ invoiceId: string }>({
    mutationFn: () =>
      apiPost<{ invoiceId: string }>(operationsClient, jobEndpoints.billPrepaidTerm(jobId), {}),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: invoiceKeys.byJobPrefix(jobId) });
      void queryClient.invalidateQueries({ queryKey: jobKeys.financialSummary(jobId) });
      void queryClient.invalidateQueries({ queryKey: jobKeys.detail(jobId) });
      toast.success('Term invoice created');
    },
  });
}
